/** @flow */

import React from "react";
import { localize } from "redux-i18n";
import { connect } from "react-redux";
import { compose } from "redux";
import { ColumnsContainer } from "@components";
import { formatDate } from "@transformers/date";
import { getStaffGroupsLabels } from "@modules/shared/selectors/staff-groups";
import type { State } from "@store/reducers";

type OwnProps = $Exact<{
  data: Object,
}>;

type PropsFromState = $Exact<{
  staffGroups: string,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromState,
  ...PropsFromLocalize,
}>;

export class StepFiltersView extends React.Component<Props> {
  get filtersOptions() {
    return [
      {
        columns: [
          {
            data: [
              [
                this.props.t("REPORT_FILTER_DATE_RANGE"),
                this.props.data.dateRange
                  ? this.props.t(this.props.data.dateRange)
                  : this.props.t("CUSTOM"),
              ],
              [
                this.props.t("OUTCOME"),
                (this.props.data.outcome || []).map(o => this.props.t(o)).join(", ") ||
                  this.props.t("ALL"),
              ],
              [
                this.props.t("APPEAL_REASONS"),
                (this.props.data.appealReasons || []).join(", ") || this.props.t("ALL"),
              ],
            ],
          },
          {
            data: [
              [
                this.props.t("FROM_DATE"),
                this.props.data.fromDate ? formatDate(this.props.data.fromDate) : "",
              ],
              [
                this.props.t("KPI_STATUS"),
                this.props.data.kpiStatus
                  ? this.props.t(this.props.data.kpiStatus)
                  : this.props.t("ALL"),
              ],
              [this.props.t("STAFF_GROUPS"), this.props.staffGroups || this.props.t("ALL")],
            ],
          },
          {
            data: [
              [
                this.props.t("TO_DATE"),
                this.props.data.toDate ? formatDate(this.props.data.toDate) : "",
              ],
            ],
          },
        ],
      },
    ];
  }

  render() {
    return <ColumnsContainer className="w-100" rows={this.filtersOptions} />;
  }
}

const mapStateToProps = (state: State, ownProps: OwnProps): PropsFromState => ({
  staffGroups: getStaffGroupsLabels(
    state,
    ((ownProps.data || {}).staffGroups || []).map(staffGroup => staffGroup.id),
  ),
});

export default compose(connect(mapStateToProps, null), localize())(StepFiltersView);
